export default __webpack_public_path__ + "static/media/O-069.b1950b55.png";